import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CrossIcon } from "../SvgIcons/allIcons";

const DeleteModal = ({ show, handleClose, handleDelete }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={!!show}
      onHide={handleClose}
      centered
      dialogClassName="custom-modal"
    >
      <Modal.Header className="deleteUser_ModalHeader" closeButton={false}>
        <Modal.Title>{t("warning.deleteWarning")}</Modal.Title>
        <Button variant="link" onClick={handleClose} className="close_Btn">
          <CrossIcon />
        </Button>
      </Modal.Header>

      <Modal.Footer className="deleteUser_ModalFooter">
        <Button
          variant="secondary"
          className="userBtn btn-theme"
          type="button"
          onClick={() => handleDelete(show)}
        >
          {t("warning.yesDelete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
